import { render, staticRenderFns } from "./BilletDescription.vue?vue&type=template&id=2a21e644&scoped=true"
import script from "./BilletDescription.vue?vue&type=script&lang=js"
export * from "./BilletDescription.vue?vue&type=script&lang=js"
import style0 from "./BilletDescription.vue?vue&type=style&index=0&id=2a21e644&prod&lang=scss&scoped=true"
import style1 from "./BilletDescription.vue?vue&type=style&index=1&id=2a21e644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21e644",
  null
  
)

export default component.exports